import { useState } from 'react';
import styled from 'styled-components';
import { contactTranslations } from '../../locales/contactTranslations';
import geneticmutation from '../../assets/genetic-mutation.webp';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20px;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
`;

const Title = styled.h2`
  color: white;
  font-size: 2.5rem;
  margin-bottom: 50px;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 2rem;
    margin-bottom: 30px;
  }
`;

const ContactSection = styled.div`
  background: rgba(0, 0, 0, 0);
  border-radius: 15px;
  padding: 30px;
  width: 100%;
  margin-bottom: 30px;
`;

const ContactInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 80px;
`;

const InfoItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Label = styled.h3`
  color: white;
  font-size: 1.2rem;
  margin: 0;
`;

const Text = styled.p`
  color: rgba(255, 255, 255, 0.9);
  font-size: 1rem;
  line-height: 1.6;
  margin: 0;

  /* Allow text to be draggable */
  user-select: text;
  cursor: text;
`;

const ImageContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 20px;
  position: relative;
  width: 100px;
  height: auto;
`;

const Image = styled.img`
  width: 100px;
  height: auto;
  border-radius: 10px;
  opacity: ${(props) => (props.$loaded ? 1 : 0)};
  transition: opacity 0.3s ease;
`;

const Spinner = styled.div`
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: spin 1s linear infinite;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

function ContactTab({ currentLang }) {
  const { title, email, address, addressText } = contactTranslations[currentLang];
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <Container>
      <Title>{title}</Title>
      <ContactSection>
        <ContactInfo>
          <InfoItem>
            <Label>{email}</Label>
            <Text>contact@withbumblebee.com</Text>
          </InfoItem>
          <InfoItem>
            <Label>{address}</Label>
            <Text>{addressText}</Text>
          </InfoItem>
        </ContactInfo>
        <ImageContainer>
          {!imageLoaded && <Spinner />}
          <Image
            src={geneticmutation}
            alt="Genetic Mutation"
            onLoad={() => setImageLoaded(true)}
            $loaded={imageLoaded}
          />
        </ImageContainer>
      </ContactSection>
    </Container>
  );
}

export default ContactTab;
